var styles = {"box":"InfoTooltip_box_1is8q_1","icon-wrapper":"InfoTooltip_icon-wrapper_1is8q_9","content":"InfoTooltip_content_1is8q_16","anchor":"InfoTooltip_anchor_1is8q_28","medium_outline":"InfoTooltip_medium_outline_1is8q_31","small_fill":"InfoTooltip_small_fill_1is8q_34","white_icon":"InfoTooltip_white_icon_1is8q_34","popup":"InfoTooltip_popup_1is8q_40","white":"InfoTooltip_white_1is8q_34"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
